module.exports = __webpack_public_path__ + "img/upload_bg.b129648d.svg";